import { motion } from "framer-motion";
import { useEffect  } from "react";
import { useTranslation } from "react-i18next";
import { BiMoon, BiSun } from "react-icons/bi";
import { MdLanguage } from "react-icons/md";
import i18n from "../../../react-i18next-ex/i18next";
import { changeLanguage } from "../utils/ChangeLanguage";
import { toLight } from "./ChangeTheme";

const MenueItems = ({ setIsMenuOpen }) => {
  const { t } = useTranslation();
  useEffect(() => {
    const screenTheme = document.documentElement.classList;
    let theme = localStorage.getItem("theme");
    let language = localStorage.getItem("language");
    if (theme) {
      if (theme === "lightTheme") {
        return document.documentElement.classList.remove("dark");
      } else {
        screenTheme.add("dark");
      }
    } else {
      screenTheme.add("dark");
    }
    if (language) {
      i18n.changeLanguage(language);
      if (language === "fa") {
        document.documentElement.dir = "rtl";
      } else {
        document.documentElement.dir = "ltr";
      }
    } else {
      i18n.changeLanguage("en");
    }
  }, []);
  return (
    <motion.ul
      className="mt-32 z-20"
      variants={{
        open: {
          transition: { staggerChildren: 0.1, delayChildren: 0.3 },
        },
        closed: {
          transition: { staggerChildren: 0.05 },
        },
      }}
    >
      <motion.li
        key={"001"}
        className="my-8 text-[20px] font-bold "
        variants={{
          open: {
            y: 0,
            opacity: 1,
            transition: {
              y: { stiffness: 1000, velocity: -100 },
            },
          },
          closed: {
            y: 50,
            opacity: 0,
            transition: {
              y: { stiffness: 1000 },
            },
          },
        }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        <div className="flex justify-center">{t("home")}</div>
      </motion.li>
      <motion.li
        key={"002"}
        className="py-8  text-[20px] font-bold cursor-pointer"
        variants={{
          open: {
            y: 0,
            opacity: 1,
            transition: {
              y: { stiffness: 1000, velocity: -100 },
            },
          },
          closed: {
            y: 50,
            opacity: 0,
            transition: {
              y: { stiffness: 1000 },
            },
          },
        }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        <div className="flex justify-center cursor-pointer">{t("aboutUS")}</div>
      </motion.li>
      <motion.li
        key={"003"}
        className="py-8  text-[20px] font-bold cursor-pointer"
        variants={{
          open: {
            y: 0,
            opacity: 1,
            transition: {
              y: { stiffness: 1000, velocity: -100 },
            },
          },
          closed: {
            y: 50,
            opacity: 0,
            transition: {
              y: { stiffness: 1000 },
            },
          },
        }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        <div className="flex justify-center cursor-pointer">
          <div
            onClick={() => {
              toLight("lightTheme");
              setIsMenuOpen(false);
            }}
            className="text-[23px] cursor-pointer hidden dark:flex  "
          >
            <BiSun className="self-center " /> {t("theme")}
          </div>
          <div
            onClick={() => {
              toLight("DarkTheme");
              setIsMenuOpen(false);
            }}
            className="text-[23px] cursor-pointer flex dark:hidden"
          >
            <BiMoon className="self-center " /> {t("theme2")}
          </div>{" "}
        </div>
      </motion.li>
      <motion.li
        key={"004"}
        className="py-8  text-[20px] font-bold cursor-pointer"
        variants={{
          open: {
            y: 0,
            opacity: 1,
            transition: {
              y: { stiffness: 1000, velocity: -100 },
            },
          },
          closed: {
            y: 50,
            opacity: 0,
            transition: {
              y: { stiffness: 1000 },
            },
          },
        }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        <div className="flex justify-center cursor-pointer">
          <div
            className={`fa flex  ${i18n.language === "en" && "hidden"}`}
            onClick={() => {
              changeLanguage("en");
              setIsMenuOpen(false);
            }}
          >
            {t("language2")}
            <MdLanguage className="self-center " />
          </div>
          <div
            className={`fa flex  ${i18n.language === "fa" && "hidden"}`}
            onClick={() => {
              changeLanguage("fa");
              setIsMenuOpen(false);
            }}
          >
            {t("language")}

            <MdLanguage className="self-center  " />
          </div>{" "}
        </div>
      </motion.li>
    </motion.ul>
  );
};

export default MenueItems;
